// extracted by mini-css-extract-plugin
export var externalLink = "_74-0";
export var internalLinkLabel = "_74-1";